export default __webpack_public_path__ + "static/media/46264_22-36_tn.b661b1d4.jpg";